import Vue from 'vue';
import VueX from 'vuex';
import actions from './log/actions.js';

Vue.use(VueX)

export default {
    namespaced: true,
    state: {
    },
    mutations:{},
    actions,
    getters: {
    },
}

